import { Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, Router } from '@angular/router';
import { BehaviorSubject, forkJoin, Subject, takeUntil } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { MenuItem } from 'primeng/api';

@Injectable({
	providedIn: 'root',
})
export class MsBreadcrumsService {
	_breadcrumbsEvent: BehaviorSubject<MenuItem[]> = null;
	breadcrumbsItemsParent: MenuItem[] = [];

	private _unsubscribeAll: Subject<any> = new Subject<any>();
	private _onPageLoadSubscribe: any = null;
	private _onLoadSubscribe: any = null;

	constructor(
		private _router: Router,
		private _translateService: TranslateService
	) {
		this._breadcrumbsEvent = new BehaviorSubject([]);
	}

	public create() {
		return this._breadcrumbsEvent;
	}

	public destroy(): void {
		this._breadcrumbsEvent.next(null);
		if (this._onPageLoadSubscribe) {
			this._onPageLoadSubscribe.unsubscribe();
		}
		if (this._onLoadSubscribe) {
			this._onLoadSubscribe.unsubscribe();
		}
		// Unsubscribe from all subscriptions
		this._unsubscribeAll.next(null);
		this._unsubscribeAll.complete();
	}

	public onPageLoad(_activatedRoute: ActivatedRoute) {
		this._onPageLoadSubscribe = _activatedRoute.data
			.pipe(takeUntil(this._unsubscribeAll))
			.subscribe(async (data) => {
				let breadcrumbItems = null;
				if (data) {
					if (data['breadcrumbsParent']) {
						this.breadcrumbsItemsParent = data.breadcrumbsParent;
					}
					if (data['breadcrumbsChildren']) {
						const breadcrumbItemsChildrenData = this.retrieveData('breadcrumbsChildren');
						breadcrumbItems = await this.addBreadcrumbItems(
							breadcrumbItems,
							breadcrumbItemsChildrenData
						);
						const items = this.breadcrumbsItemsParent.concat(breadcrumbItems);
						this._breadcrumbsEvent.next(items);
					}
				}
			});
		return this;
	}

	public instance() {
		if (!this._breadcrumbsEvent) {
			this._breadcrumbsEvent = new BehaviorSubject([]);
		}
		return this;
	}

	public onLoad(_activatedRoute: ActivatedRoute) {
		this._onLoadSubscribe = _activatedRoute.data.subscribe(async (data) => {
			const { breadcrumbsChildren } = data;
			let breadcrumbItems = null;
			breadcrumbItems = await this.addBreadcrumbItems(breadcrumbItems, breadcrumbsChildren);
			const items = this.breadcrumbsItemsParent.concat(breadcrumbItems);
			console.log(items);
			this._breadcrumbsEvent.next(items);
		});
		return this;
	}

	private async addBreadcrumbItems(value: MenuItem[], items: any[]) {
		if (items) {
			if (!value) {
				value = [];
			}

			for (let item of items) {
				let _value = '';
				let isValue = false;
				if (item['value']) {
					item = item['value'];
					isValue = true;
				}
				if (value.filter((ivalue) => ivalue === item).length === 0) {
					if (isValue) {
						_value = item;
					} else {
						_value = await this.updateValueI81N(item.label);
					}
					value.push({ label: _value });
				}
			}
		}
		return value;
	}

	private updateValueI81N(value: string): Promise<string> {
		return new Promise((resolve, reject) => {
			const _value = value || 'global.empty';
			forkJoin({
				_value: this._translateService.get(_value),
			}).subscribe((data: any[string]) => {
				resolve(data._value);
			});
		});
	}

	private getData(routeSnapshot: ActivatedRouteSnapshot, name: string): any {
		const title: string = routeSnapshot.data[name] ?? null;
		if (routeSnapshot.firstChild) {
			return this.getData(routeSnapshot.firstChild, name) || title;
		}
		return title;
	}

	private retrieveData(name): any {
		return this.getData(this._router.routerState.snapshot.root, name);
	}
}
